//const products=[];

//export function getCurrentData() { return products; }
export function getData(t, module, company){

  //products.splice(0, products.length);
  const products = [];

  const productCount = + t(`${module}.company.${company}.products.count`);
  for(let i = 1; i < productCount+1; i++){
    const titledCount = + t(`${module}.company.${company}.products.${i}.titled-contents.count`);
    const titledContents = [];

    for(let j = 1; j < titledCount+1; j++){
      const contentsCount = +t(`${module}.company.${company}.products.${i}.titled-contents.${j}.count`);
      const comments = [];

      for(let k = 1; k < contentsCount+1; k++)
        comments.push(t(`${module}.company.${company}.products.${i}.titled-contents.${j}.comment-${k}`));
      
      const titledContent = {
        title:t(`${module}.company.${company}.products.${i}.titled-contents.${j}.title`),
        comments
      };
      titledContents.push(titledContent);
    }

    const product = {
      company:t(`${module}.company.${company}.company-name`),
      modelName: t(`${module}.company.${company}.products.${i}.model-name`),
      modelDesc: t(`${module}.company.${company}.products.${i}.model-desc`),
      titledContents,
    };
    products.push(product);
  }

  return products;
}